import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import withModal from "../withModal";

const disableScriptNodeModalProps = {
    // Injected from Redux
    modalProps: PropTypes.shape({
        continue: PropTypes.func.isRequired,
    }).isRequired,
    isOpen: PropTypes.bool.isRequired,
};

type DisableScriptNodeModalProps = PropTypes.InferProps<typeof disableScriptNodeModalProps>;

const DisableScriptNodeModal: React.FC<DisableScriptNodeModalProps> = ({
    modalProps,
    isOpen,
}: DisableScriptNodeModalProps) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("DISABLE_SCRIPT_NODE"));

    const continueRequest = () => {
        modalProps.continue();
        hide();
    };

    return (
        <MaterialModal
            title="Disable Script Node"
            isOpen={isOpen}
            onClose={() => hide()}
            id="disable-script-node"
            maxWidth="sm"
            primaryButtonText="Continue"
            onPrimaryButtonRequest={() => continueRequest()}
        >
            <div>
                This script node has at least one child node; if you disable it, it could affect the child node query
                that depends on it. Are you sure you want to continue?
            </div>
        </MaterialModal>
    );
};

export default withModal(DisableScriptNodeModal, "DISABLE_SCRIPT_NODE");
